// 吃瓜捷克粉丝聚集地 —— 站点内容数据（仅用于前台静态展示）

export const siteStats = [
  { value: "12.8万+", label: "注册同好", icon: "ri-team-line" },
  { value: "46.2万+", label: "超话帖文", icon: "ri-chat-heart-line" },
  { value: "300+", label: "线下应援", icon: "ri-flashlight-line" },
  { value: "56城", label: "城市分站", icon: "ri-map-pin-2-line" },
];

export interface HotTopic {
  id: string;
  title: string;
  summary: string;
  tag: string;
  tagTone: "primary" | "accent" | "secondary";
  date: string;
  views: string;
  image: string;
}

export const hotTopics: HotTopic[] = [
  {
    id: "hot-1",
    title: "全新舞台造型曝光，粉丝直呼“太会了”",
    summary: "近期公开的一组新造型以暖珊瑚为主色调，细节设计与舞台光影高度契合，短短数小时内相关讨论热度飙升。",
    tag: "超话热点",
    tagTone: "primary",
    date: "09-05",
    views: "8.6万阅读",
    image: "https://readdy.ai/api/search-image?query=Elegant%20performer%20silhouette%20on%20stage%20bathed%20in%20warm%20coral%20gel%20lighting%2C%20dreamy%20backstage%20glow%2C%20floating%20sparkles%20and%20confetti%2C%20youthful%20celebrity%20fan%20editorial%20style%2C%20cream%20and%20peach%20palette%2C%20high%20detail%20artistic%20photography&width=900&height=600&seq=news-style-01&orientation=landscape",
  },
  {
    id: "hot-2",
    title: "年度应援企划正式启动，多方同步上线",
    summary: "本年度应援企划涵盖大屏、公益与线上话题三个方向，多个城市分站已同步开启筹备，报名入口陆续开放。",
    tag: "应援公告",
    tagTone: "accent",
    date: "09-04",
    views: "5.2万阅读",
    image: "https://readdy.ai/api/search-image?query=City%20lights%20with%20large%20outdoor%20screen%20glowing%20warm%20coral%20and%20gold%20at%20dusk%2C%20supportive%20crowd%20silhouettes%20holding%20light%20sticks%20up%2C%20festive%20atmosphere%2C%20youthful%20fan%20campaign%20scene%2C%20cream%20tones%2C%20editorial%20photography&width=900&height=600&seq=news-fanrun-01&orientation=landscape",
  },
  {
    id: "hot-3",
    title: "线上话题活动开启，晒出你的应援方式",
    summary: "围绕“与捷克的双向奔赴”主题，社区发起线上互动，参与即有机会获得限定电子特典与周边抽奖资格。",
    tag: "活动招募",
    tagTone: "secondary",
    date: "09-03",
    views: "3.9万阅读",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimal%20flatlay%20of%20photocards%20light%20stick%20and%20small%20heart%20notes%20on%20cream%20background%2C%20soft%20morning%20light%2C%20coral%20and%20peach%20accents%2C%20playful%20fan%20merch%20arrangement%2C%20high%20detail%20editorial&width=900&height=600&seq=news-online-01&orientation=landscape",
  },
  {
    id: "hot-4",
    title: "城市公益联名应援圆满落幕",
    summary: "以“捷克之名”开展的助学与环保公益应援顺利完成，相关善款与物资明细已在本站与官方渠道同步公示。",
    tag: "公益应援",
    tagTone: "accent",
    date: "09-01",
    views: "2.7万阅读",
    image: "https://readdy.ai/api/search-image?query=Volunteers%20in%20warm%20cream%20and%20coral%20uniforms%20sorting%20donated%20boxes%20together%20in%20bright%20community%20hall%2C%20warm%20sunlight%2C%20heartwarming%20charity%20campaign%20scene%2C%20youthful%20and%20hopeful%2C%20editorial%20photography&width=900&height=600&seq=news-public-01&orientation=landscape",
  },
  {
    id: "hot-5",
    title: "最新周边系列预告发布，主题公开",
    summary: "以“夏日限定·西瓜季”为主题的新周边系列正式曝光概念图，含应援棒、小卡与手幅等多款单品。",
    tag: "周边上新",
    tagTone: "secondary",
    date: "08-30",
    views: "4.1万阅读",
    image: "https://readdy.ai/api/search-image?query=Modern%20product%20preview%20of%20coral%20light%20stick%20and%20watermelon%20green%20photocard%20set%20on%20clean%20cream%20studio%20background%2C%20fresh%20summer%20feel%2C%20soft%20shadows%2C%20playful%20product%20photography%2C%20high%20detail&width=900&height=600&seq=news-merch-01&orientation=landscape",
  },
  {
    id: "hot-6",
    title: "见面会互动环节剧透，现场还有惊喜彩蛋",
    summary: "本场见面会除演唱与互动外，将增设粉丝心愿墙与神秘彩蛋环节，参与方式与注意事项请留意后续公告。",
    tag: "见面会",
    tagTone: "primary",
    date: "08-28",
    views: "6.0万阅读",
    image: "https://readdy.ai/api/search-image?query=Intimate%20fan%20meetup%20stage%20with%20warm%20coral%20decorations%2C%20string%20lights%2C%20cream%20floral%20wish%20wall%2C%20empty%20soft%20chairs%20front%2C%20cozy%20celebrity%20fan%20event%20atmosphere%2C%20editorial%20photography&width=900&height=600&seq=news-meet-01&orientation=landscape",
  },
];

export interface ActivityItem {
  id: string;
  title: string;
  desc: string;
  type: string;
  typeTone: "primary" | "accent" | "secondary";
  scope: string;
  progress: string;
  image: string;
}

export const activities: ActivityItem[] = [
  {
    id: "act-1",
    title: "城市地标大屏应援",
    desc: "生日与重要节点，在核心商圈地标大屏滚动捷克应援视频，让更多人看见来自粉丝的心意。",
    type: "大屏应援",
    typeTone: "primary",
    scope: "全国 12 城",
    progress: "进行中",
    image: "https://readdy.ai/api/search-image?query=Landmark%20city%20billboard%20displaying%20warm%20coral%20fan%20video%20at%20night%2C%20city%20street%20with%20people%20looking%20up%2C%20glowing%20gold%20and%20peach%20lights%2C%20festive%20celebrity%20fan%20campaign%2C%20editorial%20photography&width=800&height=520&seq=act-screen-01&orientation=landscape",
  },
  {
    id: "act-2",
    title: "以“捷克之名”公益应援",
    desc: "把热爱化作善意，以捷克的名义开展助学、环保与动物保护公益项目，让应援更有温度与意义。",
    type: "公益应援",
    typeTone: "accent",
    scope: "助学·环保·救助",
    progress: "透明公示",
    image: "https://readdy.ai/api/search-image?query=Warm%20handheld%20of%20colorful%20donation%20boxes%20and%20booklets%20on%20a%20bright%20sunlit%20wooden%20table%2C%20heart%20shapes%20and%20small%20plants%2C%20cozy%20charity%20project%20in%20cream%20and%20coral%20tones%2C%20editorial%20photography&width=800&height=520&seq=act-charity-01&orientation=landscape",
  },
  {
    id: "act-3",
    title: "应援棒海洋现场应援",
    desc: "见面会与演出当天，组织统一应援色与应援棒手势，用整齐的灯海为台上的捷克送上最热烈的回应。",
    type: "现场应援",
    typeTone: "secondary",
    scope: "见面会·演出",
    progress: "报名中",
    image: "https://readdy.ai/api/search-image?query=Sea%20of%20coral%20glowing%20light%20sticks%20raised%20in%20a%20dark%20concert%20venue%2C%20dreamy%20bokeh%2C%20excited%20fans%20silhouetted%2C%20warm%20peach%20and%20cream%20stage%20lighting%2C%20powerful%20emotive%20atmosphere%2C%20editorial&width=800&height=520&seq=act-live-01&orientation=landscape",
  },
];

export interface SupportChannel {
  icon: string;
  title: string;
  desc: string;
  tone: "primary" | "accent" | "secondary";
}

export const supportChannels: SupportChannel[] = [
  {
    icon: "ri-bookmark-3-line",
    title: "超话签到打卡",
    desc: "每天在超话签到、发帖，为超话热度与排名持续助力，让更多人看到捷克与粉丝的日常。",
    tone: "primary",
  },
  {
    icon: "ri-group-line",
    title: "加入城市后援会",
    desc: "找到自己所在城市的分站，参与线下聚会、应援分工与物资统筹，结识同城同好。",
    tone: "accent",
  },
  {
    icon: "ri-heart-3-line",
    title: "认领应援分工",
    desc: "无论是文案、设计、摄影还是统筹，都能在企划中找到适合你的角色，为应援出一份力。",
    tone: "secondary",
  },
];

export interface MerchItem {
  id: string;
  name: string;
  price: string;
  category: string;
  desc: string;
  image: string;
}

export const merchItems: MerchItem[] = [
  {
    id: "m-1",
    name: "捷克应援棒 · 珊瑚限定",
    price: "¥59",
    category: "应援周边",
    desc: "官方应援色珊瑚红，柔和发光，入手轻盈，大小场次都适用。",
    image: "https://readdy.ai/api/search-image?query=Single%20coral%20pink%20glow%20light%20stick%20standing%20on%20clean%20cream%20studio%20background%2C%20soft%20glow%2C%20warm%20even%20lighting%2C%20minimal%20playful%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-stick-01&orientation=squarish",
  },
  {
    id: "m-2",
    name: "高清小卡礼盒 · 十张装",
    price: "¥49",
    category: "限量特典",
    desc: "多套主题高清小卡，磨砂封套保护，礼盒装自留送人都合适。",
    image: "https://readdy.ai/api/search-image?query=Neat%20fan%20photocard%20collection%20spread%20out%20on%20soft%20cream%20background%2C%20coral%20and%20watermelon%20green%20hues%2C%20elegant%20cardboard%20box%2C%20warm%20studio%20light%2C%20minimal%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-card-01&orientation=squarish",
  },
  {
    id: "m-3",
    name: "限定珍藏海报 · A2",
    price: "¥39",
    category: "应援周边",
    desc: "珍藏级印刷，色彩还原度高，附赠无痕贴纸方便悬挂收藏。",
    image: "https://readdy.ai/api/search-image?query=Rolled%20and%20flat%20art%20poster%20with%20abstract%20warm%20coral%20stage%20artwork%20on%20cream%20desk%2C%20soft%20shadow%2C%20minimal%20elegant%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-poster-01&orientation=squarish",
  },
  {
    id: "m-4",
    name: "2026 应援年历 · 粉丝版",
    price: "¥45",
    category: "生活周边",
    desc: "十二个月主题插画，标注重要纪念日与应援节点，实用又有纪念意义。",
    image: "https://readdy.ai/api/search-image?query=Open%20wall%20calendar%20with%20coral%20and%20cream%20monthly%20illustrations%20on%20clean%20wooden%20surface%2C%20warm%20morning%20light%2C%20minimal%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-cal-01&orientation=squarish",
  },
  {
    id: "m-5",
    name: "应援徽章 · 双色套装",
    price: "¥35",
    category: "应援周边",
    desc: "珊瑚红与西瓜绿双色徽章，造型小巧，可别于衣物、背包与应援手幅。",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20round%20enamel%20pins%20in%20coral%20pink%20and%20watermelon%20green%20on%20cream%20fabric%2C%20soft%20shadow%2C%20warm%20lighting%2C%20minimal%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-badge-01&orientation=squarish",
  },
  {
    id: "m-6",
    name: "星光帆布托特包",
    price: "¥69",
    category: "生活周边",
    desc: "加厚帆布，包面点缀星光烫印，通勤看演出都方便，容量能装下手幅。",
    image: "https://readdy.ai/api/search-image?query=Natural%20canvas%20tote%20bag%20with%20subtle%20coral%20star%20print%20hanging%20against%20cream%20wall%2C%20warm%20soft%20lighting%2C%20minimal%20lifestyle%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-bag-01&orientation=squarish",
  },
  {
    id: "m-7",
    name: "手机气囊支架 · 西瓜绿",
    price: "¥19",
    category: "生活周边",
    desc: "可反复粘贴的硅胶气囊支架，西瓜绿点缀日常，追更动态更方便。",
    image: "https://readdy.ai/api/search-image?query=Watermelon%20green%20round%20phone%20grip%20holder%20on%20cream%20phone%20case%20on%20soft%20surface%2C%20warm%20minimal%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-grip-01&orientation=squarish",
  },
  {
    id: "m-8",
    name: "大会场应援手幅",
    price: "¥29",
    category: "应援周边",
    desc: "高密度面料，锁边牢固，印有统一应援标语，是现场最整齐的“移动应援”。",
    image: "https://readdy.ai/api/search-image?query=Wide%20cream%20fabric%20cheering%20banner%20with%20coral%20text%20draped%20over%20wooden%20bar%20on%20soft%20neutral%20background%2C%20warm%20lighting%2C%20minimal%20product%20photography%2C%20high%20detail&width=700&height=700&seq=merch-flag-01&orientation=squarish",
  },
];

export interface Meetup {
  city: string;
  venue: string;
  date: string;
  status: string;
  statusTone: "primary" | "accent" | "secondary";
}

export const meetups: Meetup[] = [
  {
    city: "上海",
    venue: "梅赛德斯·文化中心",
    date: "2026.10.18",
    status: "报名中",
    statusTone: "primary",
  },
  {
    city: "成都",
    venue: "西南演艺中心",
    date: "2026.11.02",
    status: "即将开票",
    statusTone: "accent",
  },
  {
    city: "北京",
    venue: "生日限定见面会",
    date: "2026.12.05",
    status: "筹备中",
    statusTone: "secondary",
  },
  {
    city: "广州",
    venue: "年末答谢见面会",
    date: "2026.12.20",
    status: "待定",
    statusTone: "secondary",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "如何加入吃瓜捷克超话？",
    a: "在支持超话的平台内搜索“吃瓜捷克超话”，点击关注并完成每日签到即可。签到能提升超话热度与话题排名，记得每天来打卡，也可以带上话题发布与捷克相关的动态、作品与日常分享。",
  },
  {
    q: "怎么加入官方后援会？",
    a: "本站“加入社群”入口面向所有注册同好开放。填写你的昵称、所在城市与常用邮箱后，我们会按城市把资料推送给对应分站，由分站负责拉群并安排新人引导，通常会在 1—3 个工作日内与你联系。",
  },
  {
    q: "粉丝周边在哪里购买？",
    a: "本站展示的是周边最新系列与概念预告，实际下单需跳转官方周边店铺。请务必认准页面与公告中公布的官方链接，谨防假冒渠道；限量与特典商品请以官方发布时间为准。",
  },
  {
    q: "见面会门票如何获取？",
    a: "见面会门票一般通过官方售票平台与粉丝定向渠道发售，具体开票时间、场次与实名要求会提前在公告与页面“见面会”板块同步。请勿轻信非官方转票信息，谨防被骗。",
  },
  {
    q: "如何参与线下应援活动？",
    a: "在页面“应援现场”板块查看你所在城市的应援计划与报名进度，通过后援会分站完成报名即可。参与时请遵守现场秩序与场馆规定，做到有序应援、文明追更。",
  },
  {
    q: "应援或合作相关咨询联系谁？",
    a: "关于应援企划、公益项目或渠道合作，可通过页面“联系方式”发送邮件至 fanclub@chiguajieke.cn，工作人员会在 3 个工作日内回复。粉丝个人问题建议优先加入后援会分站咨询。",
  },
];

export const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#hot", label: "超话热榜" },
  { href: "#support", label: "后援应援" },
  { href: "#merch", label: "粉丝周边" },
  { href: "#meetup", label: "见面会" },
  { href: "#faq", label: "常见问题" },
];